/**
 * QuickTapsPageV2 — redesigned shell for the Quick Taps list.
 *
 * The in-app tab description (general_settings.quick_tap_intro) is
 * edited inline via InAppDescriptionPanel under the header (per CMS
 * feedback, Monday #12171251310 — it used to hide behind an "Update
 * intro" modal). Saves via the existing `updateQuickTapsIntro` action
 * (PUT /general-info/quick_tap_intro).
 *
 * Header actions (mirroring the prototype's `.title-actions` cluster at
 * line 5862–5866):
 *   • "Manage Featured →" — link to /quick-taps/featured for the
 *     featured-sort UI
 *   • "+ New Quick Tap" — coral primary, navigates to /quick-taps/add
 */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import QuickTapsTableV2 from '../../QuickTapsTable/v2/QuickTapsTableV2';
import {
  fetchQuickTapsIntro,
  updateQuickTapsIntro,
} from '../../../actions/quickTapsActions';
import { PageHeader, Button, InAppDescriptionPanel } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function QuickTapsPageV2() {
  const dispatch = useDispatch();
  const intro = useSelector(
    (s) => s.general_data?.general_data?.quick_tap_intro || '',
  );

  useEffect(() => {
    dispatch(fetchQuickTapsIntro());
  }, [dispatch]);

  // Total chip reads from the paginated slice (populated by the table's
  // fetch). For a v1-style absolute count, the API's total_count is the
  // source of truth — works regardless of which page you're viewing.
  const total = useSelector((s) => s.quick_taps.paginated?.total_count ?? 0);
  const hasLoaded = useSelector((s) => s.quick_taps.paginatedLoading || s.quick_taps.paginated?.data?.length > 0);
  const totalLabel = hasLoaded ? `${total.toLocaleString()} items` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Quick Taps"
        total={totalLabel}
        actions={
          <>
            <Link to="/quick-taps/featured" className="no-underline">
              <Button variant="default" trailingIcon={<span aria-hidden>→</span>}>
                Manage Featured
              </Button>
            </Link>
            <Link to="/quick-taps/add" className="no-underline">
              <Button variant="coral" leadingIcon={PlusSign}>New Quick Tap</Button>
            </Link>
          </>
        }
      />
      <InAppDescriptionPanel
        tabName="Quick Taps"
        value={intro}
        onSave={(value) => dispatch(updateQuickTapsIntro(value))}
      />
      <QuickTapsTableV2 />
    </div>
  );
}
